import { render, staticRenderFns } from "./BreadDataRecordView.vue?vue&type=template&id=119f099e&scoped=true&"
import script from "./BreadDataRecordView.vue?vue&type=script&lang=js&"
export * from "./BreadDataRecordView.vue?vue&type=script&lang=js&"
import style0 from "./BreadDataRecordView.vue?vue&type=style&index=0&id=119f099e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119f099e",
  null
  
)

export default component.exports